export default __webpack_public_path__ + "static/media/carosello6.218e4712.png";